import { Component, OnInit } from "@angular/core";
import { MatSnackBar } from '@angular/material/snack-bar';
import { FiscalClosureModel } from "../fiscal-closure.model";
import { FiscalClosureConst } from "../fiscal-closure.conts";
import { PeriodService } from "../../../../services/period/period.service";
import { DialogsService } from "../../../../shared/components/dialogs/dialogs.service";
import { TableTitleAction } from "../../../../shared/ui/custom-table/components/custom-table-title/custom-table-title.component";

@Component({
    selector: 'convfact-fiscal-closure-list',
    templateUrl: './fiscal-closure-list.component.html',
    styleUrls: ['./fiscal-closure-list.component.css'],
    standalone: false
})

export class FiscalClosureListComponent implements OnInit {

  public ready: boolean = false;
  public selectedUids: string[] = [];

  get hasSelected(): boolean { return this.selectedUids.length > 0; }
  get openCount(): number { return this.dataSource.filter(m => m.estado === 'Abierto').length; }

  get headerSubTitle(): string {
    const n = this.openCount;
    return `${n} período${n !== 1 ? 's' : ''} abierto${n !== 1 ? 's' : ''} del ejercicio actual`;
  }

  get headerActions(): TableTitleAction[] {
    if (!this.hasSelected) return [];
    const n = this.selectedUids.length;
    return [{
      label: `Cerrar ${n} seleccionado${n !== 1 ? 's' : ''}`,
      icon: 'lock',
      variant: 'danger',
      onClick: () => { this.cierre(this.selectedUids); this.selectedUids = []; },
    }];
  }

  isSelected(uid: string): boolean { return this.selectedUids.includes(uid); }

  toggleSelect(uid: string): void {
    const idx = this.selectedUids.indexOf(uid);
    if (idx === -1) this.selectedUids.push(uid);
    else this.selectedUids.splice(idx, 1);
  }

  toggleSelectAll(): void {
    const open = this.dataSource.filter(m => m.estado === 'Abierto').map(m => m.uid);
    if (this.selectedUids.length === open.length) this.selectedUids = [];
    else this.selectedUids = [...open];
  }

  get quarters() {
    const defs = [
      { label: 'T1', range: 'Ene – Mar', months: this.dataSource.slice(0, 3) },
      { label: 'T2', range: 'Abr – Jun', months: this.dataSource.slice(3, 6) },
      { label: 'T3', range: 'Jul – Sep', months: this.dataSource.slice(6, 9) },
      { label: 'T4', range: 'Oct – Dic', months: this.dataSource.slice(9, 12) },
    ];
    return defs.map(q => ({
      ...q,
      openUids: q.months.filter(m => m.estado === 'Abierto').map(m => m.uid),
    }));
  }

  cierreQuarter(openUids: string[]): void {
    if (openUids.length) this.cierre(openUids);
  }

  public dataSource: FiscalClosureModel[] = [
    { uid: '550e8400-e29b-41d4-a716-446655440000', numeroMes: 1, mes: 'Enero', estado: 'Abierto' },
    { uid: '550e8400-e29b-41d4-a716-446655440001', numeroMes: 2, mes: 'Febrero', estado: 'Abierto' },
    { uid: '550e8400-e29b-41d4-a716-446655440002', numeroMes: 3, mes: 'Marzo', estado: 'Abierto' },
    { uid: '550e8400-e29b-41d4-a716-446655440003', numeroMes: 4, mes: 'Abril', estado: 'Abierto' },
    { uid: '550e8400-e29b-41d4-a716-446655440004', numeroMes: 5, mes: 'Mayo', estado: 'Abierto' },
    { uid: '550e8400-e29b-41d4-a716-446655440005', numeroMes: 6, mes: 'Junio', estado: 'Abierto' },
    { uid: '550e8400-e29b-41d4-a716-446655440006', numeroMes: 7, mes: 'Julio', estado: 'Abierto' },
    { uid: '550e8400-e29b-41d4-a716-446655440007', numeroMes: 8, mes: 'Agosto', estado: 'Abierto' },
    { uid: '550e8400-e29b-41d4-a716-446655440008', numeroMes: 9, mes: 'Septiembre', estado: 'Abierto' },
    { uid: '550e8400-e29b-41d4-a716-446655440009', numeroMes: 10, mes: 'Octubre', estado: 'Abierto' },
    { uid: '550e8400-e29b-41d4-a716-446655440010', numeroMes: 11, mes: 'Noviembre', estado: 'Abierto' },
    { uid: '550e8400-e29b-41d4-a716-446655440011', numeroMes: 12, mes: 'Diciembre', estado: 'Abierto' }
  ];

  public headerTable: any[] = FiscalClosureConst.headerTable;

  constructor(
    public snackBar: MatSnackBar,
    public periodService: PeriodService,
    public dialogsService: DialogsService,
  ) { }

  ngOnInit() {

    this.periodService.getMonthsClosedPeriod().subscribe(response => {

      const mesesNumeros: number[] = response['data'];

      this.dataSource.forEach((x) => {
        if (mesesNumeros.includes(x.numeroMes)) {
          x.estado = "Cerrado";
        }
      });

      this.ready = true;

    }, (error) => {
      this.snackBar.open('Ha ocurrido un error en la obtencion de los estados de periodos', null, { duration: 3000 });
    });

  }

  public cierre(selectedUids: string[]): void {

    const filterSource = this.dataSource.filter(x => selectedUids.includes(x.uid));

    if (filterSource.find(x => x.estado === 'Cerrado')) {
      this.snackBar.open('Uno de los periodos seleccionados ya se encuentra cerrado', null, { duration: 3000 });
      return;
    }

    const monthsNumbers: number[] = filterSource.map(x => x.numeroMes);

    this.dialogsService.confirm('Cierre fiscal', '¿Estás seguro de que deseas realizar el cierre fiscal? Esta acción es irreversible y no podrás reabrirlo posteriormente')
      .subscribe((res: boolean) => {
        if (res === true) {

          this.periodService.closePeriod(monthsNumbers).subscribe(response => {

            const result = response['data'];

            if (result) {

              this.dataSource.forEach((x) => {
                if (selectedUids.includes(x.uid)) {
                  x.estado = "Cerrado";
                }
              });

              this.snackBar.open('El periodo se ha cerrado correctamente', null, { duration: 3000 });

            } else {

              this.snackBar.open('Ha ocurrido un problema al intentar realizar el cierre', null, { duration: 3000 });

            }

          }, (error) => {
            this.snackBar.open('Ha ocurrido un error inesperado al intentar realizar el cierre', null, { duration: 3000 });
          });

        } else { }

      });
  }

  public trackByIndex(i: number) { return i; }

}
